import { render, staticRenderFns } from "./UpdateUniqueIdModal.vue?vue&type=template&id=3c1b9648&"
import script from "./UpdateUniqueIdModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUniqueIdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateUniqueIdModal.vue"
export default component.exports